export const avatar = require("./avatar.jpg");
export const eth = require("./eth.png");
export const bitcoin = require("./bitcoin.png");
export const mastercard = require("./mastercard.png");
export const paypal = require("./paypal.png");
export const wm = require("./wm.png");
export const visa = require("./visa.png");

export const acceptedBets = require("./acceptedBets.png");
export const createdBets = require("./createdBets.png");
export const envelope = require("./envelope.png");
export const wallet = require("./wallet.png");



// WEBPACK FOOTER //
// ./src/assets/images/personalRoom/index.js